export function FolderOfflineIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M6 3a3 3 0 00-3 3v12a3 3 0 003 3h5.528A6 6 0 0021 13.682V10a3 3 0 00-3-3h-4.5l-2.1-2.8A3 3 0 009 3H6zm4 14c0 .701.12 1.374.341 2H6a1 1 0 01-1-1V9h13a1 1 0 011 1v1.803A6 6 0 0010 17zm1-10L9.8 5.4A1 1 0 009 5H6a1 1 0 00-1 1v1h6zm5.084 6.374l-2.566 3.849a.5.5 0 00.416.777H15v2.5a.5.5 0 00.9.3l3-4a.5.5 0 00-.4-.8H17v-2.349a.5.5 0 00-.916-.277z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}
